import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-763af23b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "blue",
  id: "achievements"
}
const _hoisted_2 = {
  class: "template",
  id: "blurb"
}
const _hoisted_3 = ["data-aos"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "53+", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "center" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "PROJECTS COMPLETED"),
  /*#__PURE__*/_createElementVNode("p", null, "Over the past 7 years, I have completed over 50 software projects, both for clients and myself. These projects include iOS/Android apps, websites, Mac/Windows programs, backend APIs, and even a few data analytics dashboards.")
], -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]

import { useLanguageSwitcher } from '@/composables/useLanguageSwitcher';
import { FadeDown, FadeLeft, FadeRight } from '@/constants/app';


export default /*#__PURE__*/_defineComponent({
  __name: 'StatsHeader',
  setup(__props) {

const { t } = useLanguageSwitcher();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        "data-aos": _unref(FadeRight),
        class: "grid"
      }, _hoisted_6, 8, _hoisted_3)
    ])
  ]))
}
}

})